import React from 'react'
import { Button as ButtonAnt } from 'antd'
import { ButtonProps } from 'antd/lib/button'

import { useT } from 'src/core/hooks/use-translation'

import { Tooltip } from '..'

function Button({
  size = 'large',
  title,
  type = 'primary',
  children,
  ...props
}: ButtonProps) {
  const { t } = useT()

  return (
    <ButtonAnt size={size} type={type} {...props}>
      {t(title)}
      {children}
    </ButtonAnt>
  )
}

function ButtonTitled({ tooltip, ...props }: ButtonProps & { tooltip: any }) {
  return (
    <Tooltip title={tooltip}>
      <Button {...props} />
    </Tooltip>
  )
}

export { Button, ButtonTitled }
